export default "__VITE_PUBLIC_ASSET__02e0eaf2__"